export const POLICY_TRANSACTION_PRIVILEGES = {
  addPolicy: {
    access: "transactions.addPolicy.access",
    bulkUpload: "transactions.bulkPolicyUpload",
    bulkTemplateDownload: "transactions.bulkPolicyTemplateDownload",
    bulkRetailUpload: "transactions.bulkRetailPolicyUpload",
    bulkCorporateUpload: "transactions.bulkCorporatePolicyUpload"
  },
  draftPolicies: {
    access: "transactions.draftPolicies.access",
    delete: "transactions.draftPolicyDelete"
  }
};
